/**
 * DevExtreme (ui/pivot_grid_field_chooser.js)
 * Version: 19.2.6
 * Build date: Thu Jan 30 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
module.exports = require("./pivot_grid/ui.pivot_grid.field_chooser");
module.exports.default = module.exports;



//////////////////
// WEBPACK FOOTER
// ./~/devextreme/ui/pivot_grid_field_chooser.js
// module id = 1214
// module chunks = 0